import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, Newspaper } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StoreBlog() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    document.title = "Health Blog — Trustmeds Pharma Kashipur";
    fetch(`${API}/public/blog`).then((r) => r.json()).then(setPosts).catch(() => setPosts([]));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8" data-testid="store-blog-page">
      <div className="flex items-center gap-3 mb-1">
        <div className="w-11 h-11 bg-emerald-50 rounded-2xl flex items-center justify-center">
          <Newspaper className="w-6 h-6 text-emerald-700" />
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Health Blog</h1>
      </div>
      <p className="text-sm text-slate-500 mb-6">Sehat ki jaankari, medicine guides aur health tips — Trustmeds Pharma ki taraf se.</p>

      {!posts ? (
        <div className="text-center py-16 text-slate-400 text-sm">Posts load ho rahe hain…</div>
      ) : posts.length === 0 ? (
        <div className="text-center py-16 bg-white border border-slate-200 rounded-3xl" data-testid="blog-empty">
          <Newspaper className="w-10 h-10 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-500 text-sm">Jaldi hi health tips aur guides yahan milengi!</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {posts.map((p) => (
            <Link key={p.id} to={`/store/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
              className="bg-white border border-slate-200 rounded-2xl overflow-hidden hover:shadow-lg hover:border-emerald-200 transition-all flex flex-col">
              {p.cover_image ? (
                <img src={`${process.env.REACT_APP_BACKEND_URL}${p.cover_image}`} alt={p.title} loading="lazy" className="w-full aspect-[2/1] object-cover" />
              ) : (
                <div className="w-full aspect-[2/1] bg-emerald-900 flex items-center justify-center">
                  <Newspaper className="w-10 h-10 text-emerald-300" />
                </div>
              )}
              <div className="p-4 flex flex-col flex-1">
                <h2 className="font-semibold text-slate-900 leading-snug">{p.title}</h2>
                <p className="text-xs text-slate-500 mt-1.5 leading-relaxed line-clamp-2 flex-1">{p.excerpt}</p>
                <div className="mt-3 flex items-center justify-between text-[11px] text-slate-400">
                  <span className="inline-flex items-center gap-1"><CalendarDays className="w-3.5 h-3.5" /> {new Date(p.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</span>
                  <span className="inline-flex items-center gap-1 text-emerald-700 font-semibold">Padhein <ArrowRight className="w-3.5 h-3.5" /></span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
